import axios from "axios";
import { LEADER_BOARD } from "../types/leaderBoard.type";

const fetch = (year) => (dispatch) =>
  axios
    .get(window.API_URL + "/leaderboards?year=" + year)
    .then(({ data }) => {
      dispatch({
        type: LEADER_BOARD.SUCCESS_FETCH,
        payload: data.data,
      });
    })
    .catch((error) => {
      console.error(error);
      dispatch({
        type: LEADER_BOARD.FAIL_FETCH,
        payload: "Something went wrong",
      });
    });

export const leaderBoardAction = {
  fetch,
};
